export default "__VITE_ASSET__BcmxhiPw__"